// Mega menü: egérrel rámutatva nyílik, egy nyitott menü egyszerre, Esc zárja.
(() => {
  const menus = Array.from(document.querySelectorAll('details.mega-menu'));
  if (!menus.length) return;

  const backdrop = document.createElement('div');
  backdrop.className = 'mega-menu-backdrop';
  document.body.appendChild(backdrop);

  const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
  const sync = () => {
    const anyOpen = menus.some((d) => d.open);
    document.body.classList.toggle('mega-menu-open', anyOpen);
  };
  const close = (d) => {
    if (!d.open) return;
    d.removeAttribute('open');
    d.querySelector('summary').setAttribute('aria-expanded', 'false');
  };
  const open = (d) => {
    menus.forEach((m) => m !== d && close(m));
    if (!d.open) {
      d.setAttribute('open', '');
      d.querySelector('summary').setAttribute('aria-expanded', 'true');
    }
  };

  menus.forEach((d) => {
    const item = d.closest('li') || d;
    let timer;
    d.addEventListener('toggle', () => {
      if (d.open) menus.forEach((m) => m !== d && close(m));
      sync();
    });
    item.addEventListener('mouseenter', () => {
      if (!hoverable.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => open(d), 90);
    });
    item.addEventListener('mouseleave', () => {
      if (!hoverable.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => close(d), 220);
    });
  });

  backdrop.addEventListener('click', () => menus.forEach(close));
  // X gomb a panel sarkában
  document.querySelectorAll('[data-mega-close]').forEach((b) => {
    b.addEventListener('click', (e) => {
      e.preventDefault();
      const d = b.closest('details.mega-menu');
      if (d) { close(d); d.querySelector('summary').focus(); }
    });
  });
  // görgetéskor (nagyobb mozdulatnál) bezárjuk
  let scrollStart = null;
  window.addEventListener('scroll', () => {
    if (!menus.some((d) => d.open)) { scrollStart = null; return; }
    if (scrollStart === null) scrollStart = window.scrollY;
    if (Math.abs(window.scrollY - scrollStart) > 120) { menus.forEach(close); scrollStart = null; }
  }, { passive: true });
  backdrop.addEventListener('mouseenter', () => {
    if (hoverable.matches) menus.forEach(close);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const openMenu = menus.find((d) => d.open);
    if (openMenu) {
      close(openMenu);
      openMenu.querySelector('summary').focus();
    }
  });
})();
